<template>
   <div class="timeline__event"  :id="'meeting-'+meeting.id">
      <div class="timeline__event__number">{{meeting.code}}</div>
      <div class="timeline__event__content">
         <div class="timeline__event__top">
            {{meeting.track}}
            <span class="icon icon--flag" v-if="isMeetingFinished(meeting)"></span>
            <span class="icon icon--chrono" v-if="isRaceSoon(meeting)"></span>
         </div>
         <div class="timeline__event__bottom timeline__event__bottom--text" v-if="isMeetingFinished(meeting)">
            {{t('timeline.meeting.finished')}}
         </div>
         <div class="timeline__event__bottom" v-if="!isMeetingFinished(meeting)">
            <span class="icon" :class="meet_class" :key="'mt-disc-'+meeting.id+'-'+meet_class" v-for="meet_class in meetingRaceIcons(meeting)"></span>
            <span class="icon " :class="'icon--w-wm-'+closestRace(meeting).weather_icon"></span>
         </div>
         <div class="timeline__event__bottom d-flex flex-row " v-if="meeting.premium">
            <game
                v-if="isBoostered"
                class="games__list__link"
                :bet="{code: 'booster'}"
                iconed
                size="xs"
            />
            <game class="games__list__link"
                :bet="{code}"
                v-for="code in meeting.premium"
                :key="'mt-prem-bet__'+snakeCase(code)+'-'+meeting.id"
                iconed
                size="xs"
            />

         </div>
      </div>
   </div>
</template>

<script>

import {uniqBy} from 'lodash';

export default {
   name: "meeting-card",
   props:{
      meeting: Object,

   },

   computed:{
      isBoostered(){

         let booster = false;
         for(let race of this.meeting.races){

            if(race.bets && Array.isArray(race.bets)){
               for(let bettype of race.bets){

                  if(null !== bettype.booster  && !isNaN(bettype.booster)  ){
                     booster = true;
                     break;
                  }
               }
               if(booster){
                  break;
               }
            }

         }

         return booster;

      },
   },
   methods:{

      closestRace(meeting){

         let race = meeting.races[meeting.races.length - 1];

         for(let i = 0; i<meeting.races.length; i++){

            if(meeting.races[i].status === 'OPEN' ){
               race = meeting.races[i];
               break;
            }
         }
         return race;

      },
      isRaceSoon(meeting){
         return meeting.races.some((race)=>{
            let time = moment(race.time).valueOf();
            time = Math.abs(time - (new Date()).valueOf());
            return time < 120000 && race.status === 'OPEN'; //If time gap is 2 minutes
         })
      },
      isMeetingFinished(meeting){


         return !meeting.races.some((race)=>{
            return race.status === 'OPEN' || race.status === 'CLOSED'
         })
      },
      meetingRaceIcons(meeting){

         let i = [];

         meeting.discipline.forEach((disc)=>{


            switch (disc) {
               case 'H':
                  //meeting.racetype

                  meeting.racetypes_string.forEach((rs)=>{

                     switch (this.snakeCase(rs)) { //Don't want to deal with french letters
                        case 'attele':
                           i.push('icon--r-trotting');
                           break;
                        case 'monte':
                           i.push('icon--r-trot');
                           break;
                     }

                  });
                  if(i.length === 0){
                     i.push('icon--r-trot');
                  }

                  break;
               case 'T':
                  let t = false;
                  meeting.racetypes_string.forEach((rs)=>{

                     switch (this.snakeCase(rs)) {
                        case 'haies':
                           t = true;
                           i.push('icon--r-hurdle');
                           break;
                        case 'plat':
                           t = true;
                           i.push('icon--r-gallop');
                           break;
                     }

                  });
                  if(!t){
                     i.push('icon--r-gallop');
                  }
                  break;
            }

         });

         return i;


         // icon icon--r-trotting, icon--r-trot, icon--r-gallop
      }
   }
}
</script>

<style scoped>

</style>
